var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TOCBUYORSELL } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import Commodity from "./Commodity/Commodity";
import Currency from "./Currency/Currency";
import EqBuySellStock from "./Equity/EqBuySellStock";
import FnOBuySellStock from "./FnO/FnOBuySellStock";
export var ETocRoutes;
(function (ETocRoutes) {
    ETocRoutes["Equity_Toc"] = "/buy-stock";
    ETocRoutes["Fno_Toc"] = "/fno";
    ETocRoutes["Esip_Toc"] = "/esip";
    ETocRoutes["Currency_Toc"] = "/currency";
    ETocRoutes["Commodity_Toc"] = "/commodity";
    ETocRoutes["Nfo_Toc"] = "/nfo";
    ETocRoutes["MF_Toc"] = "/mutualfund";
    ETocRoutes["Ncd_Toc"] = "/ncd";
})(ETocRoutes || (ETocRoutes = {}));
export var commonConverList = [
    { display: "Buy Order", value: TOCBUYORSELL.BUY },
    { display: "Sell Order", value: TOCBUYORSELL.SELL },
    { display: "Start ESIP", value: TOCBUYORSELL.SIP },
];
export var tocRoutes = [
    {
        type: "FUTCOM",
        route: ETocRoutes.Commodity_Toc,
        component: Commodity,
    },
    {
        type: "OPTFUT",
        route: ETocRoutes.Commodity_Toc,
        component: Commodity,
    },
    { type: "FUTCUR", route: ETocRoutes.Currency_Toc, component: Currency },
    { type: "OPTCUR", route: ETocRoutes.Currency_Toc, component: Currency },
    { type: "FUTSTK", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "FUTIDX", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "OPTIDX", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "OPTSTK", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    // { type: "INDEX", route: ETocRoutes.Equity_Toc, component: EqBuySellStock },
    { type: "EQUITY", route: ETocRoutes.Equity_Toc, component: EqBuySellStock },
];
export var EqAssetTypes = [
    "FUTCUR",
    "OPTCUR",
    "FUTSTK",
    "OPTSTK",
    "FUTIDX",
    "OPTIDX",
    "EQUITY",
];
export var CoAssetTypes = ["FUTCOM", "OPTFUT"];
export var isTradeableAsset = function (assertType) {
    var allTradeableAsset = __spreadArray(__spreadArray([], __read(EqAssetTypes), false), __read(CoAssetTypes), false);
    return allTradeableAsset.includes(assertType);
};
export var ITradeValuesENUM;
(function (ITradeValuesENUM) {
    ITradeValuesENUM["amount"] = "amount";
    ITradeValuesENUM["limitPrice"] = "limitPrice";
    ITradeValuesENUM["stopLoss"] = "stopLoss";
    ITradeValuesENUM["target"] = "target";
    ITradeValuesENUM["triggerPrice"] = "triggerPrice";
    ITradeValuesENUM["disclosedQuantity"] = "disclosedQuantity";
    ITradeValuesENUM["quantity"] = "quantity";
    ITradeValuesENUM["totalperiod"] = "totalperiod";
    ITradeValuesENUM["startDate"] = "startDate";
})(ITradeValuesENUM || (ITradeValuesENUM = {}));
// export enum commodityExchanges {
//   MCX = "MCX",
//   NCDEX = "NCDEX",
// }
export var exchangesData;
(function (exchangesData) {
    exchangesData["NSE"] = "NSE";
    exchangesData["BSE"] = "BSE";
    exchangesData["NFO"] = "NFO";
    exchangesData["CDS"] = "CDS";
    exchangesData["MCX"] = "MCX";
    exchangesData["NCDEX"] = "NCDEX";
})(exchangesData || (exchangesData = {}));
export var ITOCScreenStateEnum;
(function (ITOCScreenStateEnum) {
    ITOCScreenStateEnum["ORDER_CONFIRM"] = "ORDER_CONFIRM";
    ITOCScreenStateEnum["INSUFFICIENT_FUND"] = "INSUFFICIENT_FUND";
    ITOCScreenStateEnum["SPLIT_ORDER"] = "SPLIT_ORDER";
    ITOCScreenStateEnum["SPLIT_ORDER_PARTIAL"] = "SPLIT_ORDER_PARTIAL";
    ITOCScreenStateEnum["REJECTED_ORDER"] = "REJECTED_ORDER";
    ITOCScreenStateEnum["SUCCESS_ORDER"] = "SUCCESS_ORDER";
    ITOCScreenStateEnum["MARKET_DEPTH"] = "MARKET_DEPTH";
    ITOCScreenStateEnum["CHART_IQ"] = "CHART_IQ";
})(ITOCScreenStateEnum || (ITOCScreenStateEnum = {}));
export var checkTocState = function (data, type) {
    return data === type;
};
export var splitVal = function (val) {
    return val.split(".");
};
export var declarationMsg = {
    esipNrmlConsent: "Note: All E-SIP orders will be placed under \"Delivery Plus (NRML)\" product type. On E-SIP due date, system will consider total limits available for order placement including stocks collateral. The debit (if any) post the E-SIP order placement will have to be cleared within 5 days post the settlement day to avoid liquidation",
    insufficientHolding: "Note: Holding may not be sufficient for selected product type",
};
var BO_TAndC = "https://www.nuvamawealth.com/ewwebimages/webfiles/disclaimer/Bracket%20order%20-%20Terms%20and%20Conditions.pdf";
var Esip_link = "https://www.nuvamawealth.com/ewwebimages/webfiles/disclaimer/esip-tc.pdf";
export var redircetToTermeAndCond = function (isEsip) {
    var link = isEsip ? Esip_link : BO_TAndC;
    return window.open(link, "_blank");
};
export var acceptNumberOnly = function (key) {
    if (key == "-" || key == "e" || key == "E" || key == "+") {
        return true;
    }
    return false;
};
// export const getProductValues = (
//   productsAlias: Array<{ key: string; value: string }>,
//   productBtn: string
// ) => {
//   return productsAlias?.find((x) => x.value === productBtn)?.key;
// };
export var getProductValues = function (prodButtonList, productBtn) {
    var _a;
    return (_a = prodButtonList === null || prodButtonList === void 0 ? void 0 : prodButtonList.find(function (x) { return x.title == productBtn; })) === null || _a === void 0 ? void 0 : _a.mainVal;
};
export var coGetProductValues = function (prodButtonList, productBtn) {
    var _a;
    return (_a = prodButtonList === null || prodButtonList === void 0 ? void 0 : prodButtonList.find(function (x) { return x.key == productBtn; })) === null || _a === void 0 ? void 0 : _a.value;
};
export var validateTickSize = function (priceVal, tickSize) {
    var _a, _b, _c, _d;
    var price = priceVal[0] == "." ? "0".concat(priceVal) : priceVal;
    var intOfPrice = parseInt(price);
    var intOfTickSize = parseInt(tickSize);
    if (parseFloat(tickSize) !== 0) {
        var lenOfPriceAfterDecimal = 0; // l1
        var lenOfTickSizeAfterDecimal = 0; // l2
        var valOfPriceAfterDecimal = 0; // dec1
        var valOfTickSizeAfterDecimal = 0; // dec2
        if (((_a = splitVal(price)) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            lenOfPriceAfterDecimal = (_b = splitVal(price)[1]) === null || _b === void 0 ? void 0 : _b.length;
            valOfPriceAfterDecimal = Number(splitVal(price)[1]);
        }
        if (((_c = splitVal(tickSize)) === null || _c === void 0 ? void 0 : _c.length) > 1) {
            lenOfTickSizeAfterDecimal = (_d = splitVal(tickSize)[1]) === null || _d === void 0 ? void 0 : _d.length;
            valOfTickSizeAfterDecimal = Number(splitVal(tickSize)[1]);
        }
        var graterLenOfDecimalVal = lenOfPriceAfterDecimal;
        if (lenOfPriceAfterDecimal < lenOfTickSizeAfterDecimal)
            graterLenOfDecimalVal = lenOfTickSizeAfterDecimal;
        var powOfGraterLenOfDecimalVal = Math.pow(10, graterLenOfDecimalVal);
        if (powOfGraterLenOfDecimalVal > 1) {
            if (lenOfPriceAfterDecimal <= graterLenOfDecimalVal) {
                valOfPriceAfterDecimal =
                    valOfPriceAfterDecimal *
                        Math.pow(10, graterLenOfDecimalVal - lenOfPriceAfterDecimal);
                intOfPrice =
                    intOfPrice * powOfGraterLenOfDecimalVal + valOfPriceAfterDecimal;
            }
            if (lenOfTickSizeAfterDecimal <= graterLenOfDecimalVal) {
                valOfTickSizeAfterDecimal =
                    valOfTickSizeAfterDecimal *
                        Math.pow(10, graterLenOfDecimalVal - lenOfTickSizeAfterDecimal);
                intOfTickSize =
                    intOfTickSize * powOfGraterLenOfDecimalVal +
                        valOfTickSizeAfterDecimal;
            }
        }
        if (intOfPrice % intOfTickSize == 0) {
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
};
export var chargesHandler = function (tradeValue) {
    if (!tradeValue.quantity || !tradeValue.limitPrice) {
        return true;
    }
    return false;
};
export var handleLimitPriceValidation = function (limitPrice, quotesDetails) {
    if (!limitPrice || Number.isNaN(+limitPrice) || +limitPrice <= 0) {
        return {
            status: true,
            msg: "Limit price should be greater then 0",
        };
    }
    else if (+limitPrice > +quotesDetails.higherCircuit) {
        return {
            status: true,
            msg: "Price can not be above ".concat(quotesDetails.higherCircuit),
        };
    }
    else if (+limitPrice < +quotesDetails.lowerCircuit) {
        return {
            status: true,
            msg: "Price can not be less than ".concat(quotesDetails.lowerCircuit),
        };
    }
    else if (validateTickSize(limitPrice, quotesDetails.tickSize)) {
        return {
            status: true,
            msg: "Price should be multiple of Tick Size Which is \n      ".concat(quotesDetails.tickSize, " Rupees for this contract"),
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export var handleTriggerPriceValidation = function (triggerPrice, limitPrice, activeState, quotesDetails) {
    if (!triggerPrice || Number.isNaN(+triggerPrice) || +triggerPrice <= 0) {
        return {
            status: true,
            msg: "Trigger price should be greater then 0",
        };
    }
    else if (activeState === TOCBUYORSELL.BUY && +triggerPrice >= +limitPrice) {
        return {
            status: true,
            msg: "Trigger price should be less than limit price",
        };
    }
    else if (activeState === TOCBUYORSELL.BUY &&
        +triggerPrice <= +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lastTradedPrice)) {
        return {
            status: true,
            msg: "Trigger price should be greater than LTP",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +triggerPrice <= +limitPrice) {
        return {
            status: true,
            msg: "Trigger price should be greater than limit price",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +triggerPrice >= +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lastTradedPrice)) {
        return {
            status: true,
            msg: "Trigger price should be less than LTP",
        };
    }
    else if (validateTickSize(triggerPrice, quotesDetails.tickSize)) {
        return {
            status: true,
            msg: "Price should be multiple of Tick Size Which is \n      ".concat(quotesDetails.tickSize, " Rupees for this contract"),
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export var handleDiscloseQtyValidation = function (disclosedQuantity, quantity) {
    if (!!disclosedQuantity && !!quantity && +disclosedQuantity > +quantity) {
        return {
            status: true,
            msg: "Disclosed qty can not be greater than order quantity",
        };
    }
    else if (!!disclosedQuantity &&
        !!quantity &&
        +quantity / 10 > +disclosedQuantity) {
        return {
            status: true,
            msg: "Disclosed qty can not be less than 10% of the order quantity",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export var handleDiscloseQtyValidationCO = function (disclosedQuantity, quantity) {
    if (!!disclosedQuantity && !!quantity && +disclosedQuantity > +quantity) {
        return {
            status: true,
            msg: "Disclosed qty can not be greater than order quantity",
        };
    }
    else if (!!disclosedQuantity &&
        !!quantity &&
        +quantity / 4 > +disclosedQuantity) {
        return {
            status: true,
            msg: "Disclosed qty can not be less than 25% of the order quantity",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export var handleStoplossValidation = function (stopLoss, limitPrice, activeState, quotesDetails) {
    if (!stopLoss || Number.isNaN(+stopLoss) || +stopLoss <= 0) {
        return {
            status: true,
            msg: "Stop loss should be greater then 0",
        };
    }
    else if (activeState === TOCBUYORSELL.BUY &&
        +limitPrice - +stopLoss < +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lowerCircuit)) {
        return {
            status: true,
            msg: "Stop loss can not be less than lower circuit",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +stopLoss + +limitPrice > +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.higherCircuit)) {
        return {
            status: true,
            msg: "Stop loss can not be greater than higher circuit",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export var handleTargetValidation = function (target, limitPrice, activeState, quotesDetails) {
    if (!target || Number.isNaN(+target) || +target <= 0) {
        return {
            status: true,
            msg: "Target price should be greater then 0",
        };
    }
    else if (activeState === TOCBUYORSELL.BUY &&
        +target + +limitPrice > +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.higherCircuit)) {
        return {
            status: true,
            msg: "Target price can not be greater than higher circuit ",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +limitPrice - +target < +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lowerCircuit)) {
        return {
            status: true,
            msg: "Target price can not be less than lower circuit ",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export var handleQuantityValidation = function (quantity) {
    if (!quantity || (quantity && +quantity <= 0)) {
        return {
            status: true,
            msg: "Qty can not be 0 or blank",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export var handleOrderSlicingLimit = function (osl, nos, maxAllowedLots) {
    if (nos > osl) {
        return {
            status: true,
            msg: maxAllowedLots
                ? "Exceeded Qty limit! Max. Lots allowed for Square off is ".concat(maxAllowedLots, ".")
                : "You have exceeded the limit",
        };
    }
    if (nos < osl) {
        return {
            status: false,
            msg: "",
        };
    }
};
export var eCollectBankDetails = [
    { key: "Beneficiary Name", value: "Edelweiss Brocking Ltd" },
    { key: "Beneficiary Bank", value: "Citibank" },
    { key: "Bank Branch", value: "Mumbai" },
    { key: "Account Type", value: "Current Account" },
    { key: "IFSC", value: "CITI0100000" },
    { key: "Beneficiary Bank A/c Number", value: "EBL145011037" },
];
export var fieldValidationManager = function (tradeValue, activeState, quotesDetails) {
    return {
        getLimitValidation: handleLimitPriceValidation(tradeValue.limitPrice, quotesDetails),
        getTriggerValidation: handleTriggerPriceValidation(tradeValue.triggerPrice, tradeValue.limitPrice, activeState, quotesDetails),
        getTargetValidation: handleTargetValidation(tradeValue.target, tradeValue.limitPrice, activeState, quotesDetails),
        getStoplossValidation: handleStoplossValidation(tradeValue.stopLoss, tradeValue.limitPrice, activeState, quotesDetails),
        getDisclossValidation: handleDiscloseQtyValidation(tradeValue === null || tradeValue === void 0 ? void 0 : tradeValue.disclosedQuantity, tradeValue === null || tradeValue === void 0 ? void 0 : tradeValue.quantity),
        getDisclossValidationCo: handleDiscloseQtyValidationCO(tradeValue === null || tradeValue === void 0 ? void 0 : tradeValue.disclosedQuantity, tradeValue === null || tradeValue === void 0 ? void 0 : tradeValue.noOfLots),
    };
};
